import './FeedbackForm.css';

import { useState } from 'react';

export default function FeedbackForm() {
    const [feedbackType, setFeedbackType] = useState('');
    const [description, setDescription] = useState('');
    const [toastActive, setToastActive] = useState(false);

    const feedbackUrl = process.env.REACT_APP_FEEDBACK_URL;

    function changeFeedbackType(type) {
        setFeedbackType(type);
    }

    function changeDescription(description) {
        setDescription(description.substring(0, 512));
    }

    function submitFeedback() {
        fetch(feedbackUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    feedbackType,
                    description
                }),
            });

        setFeedbackType('');
        setDescription('');
        setToastActive(true);
        setTimeout(() => setToastActive(false), 3000);
    }

    return (
        <div className='feedback-form'>
            <h1 id="submit-question" className='text-center'>Question or Feedback?</h1>
            <div className="select-container">    
                <select value={feedbackType} onChange={(e) => changeFeedbackType(e.target.value)}>
                    <option value="" disabled>Select type</option>
                    <option value="Feature">Feature</option>
                    <option value="Issue">Question/Issue</option>
                </select>   
            </div>
            <div className='description-container'>
                <span>Include your email if you'd like a response.</span>
                <textarea placeholder="Description" maxLength={513} value={description} className='input' type='text' name='description' onChange={(e) => changeDescription(e.target.value)}></textarea>
                <span>512 character max.</span>           
            </div>
            <div className='text-center'>
                <button type="button" className="button-6" disabled={!feedbackType || !description} onClick={() => submitFeedback()}>Submit</button>
            </div>
            <div id="snackbar" className={toastActive ? 'show' : ''}>Thanks for the feedback!</div>
        </div>
    )
}